/**
 * 历史订单。每单是几个商品 id。
 * 真实商城这是数据库里的表;这里用固定种子在页面里生成两万单,让「买了 A 的人也买了 B」有规律可循。
 * 生成本身在模块加载时跑一次,几毫秒。
 */
let seed = 42;
const rand = () => (seed = (seed * 1664525 + 1013904223) >>> 0) / 2 ** 32;

/** 常一起买的组合。id 见 products.ts */
const bundles = [
  [4, 11, 3],   // 沙发、地毯、落地灯
  [7, 1, 3],    // 书桌、餐椅、落地灯
  [2, 12, 9],   // 边几、挂钟、壁镜
  [5, 8, 10],   // 书架、收纳篮、花盆
  [1, 6],       // 餐椅、圆凳
];

export const orders: number[][] = Array.from({ length: 20000 }, () => {
  const order = new Set<number>();
  const b = bundles[Math.floor(rand() * bundles.length)];
  for (const id of b) if (rand() < 0.7) order.add(id);
  while (order.size < 1 + Math.floor(rand() * 3)) order.add(1 + Math.floor(rand() * 12));
  return [...order];
});
